import React, { Component } from 'react';
import { withRouter } from '../util/withRouter';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class CheckPartner extends Component {
    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      if (this.props.user.isPartner) {
        this.props.router.replace('/');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return withRouter(connect(mapStateToProps)(CheckPartner));
}
